import { sync } from 'vuex-pathify';
export default {
  computed: {
    zoom: sync('map/zoom'),
  },
  methods: {
    getLayerType(layer) {
      if (!layer) return;
      return layer.type === 'features_layer' ? layer.geometry_type : layer.service_type;
    },
    getLayerIcon(layerType) {
      if (layerType === 'point' || layerType === 'multipoint') {
        return 'mdi-circle-medium';
      } else if (layerType === 'linestring' || layerType === 'multilinestring') {
        return 'mdi-chart-line-variant';
      } else if (layerType === 'polygon' || layerType === 'multipolygon') {
        return 'mdi-square-rounded';
      } else if (layerType === 'xyz' || layerType === 'wms' || layerType === 'wmts') {
        return '$wms';
      } else {
        return 'mdi-table-large';
      }
    },
    getLayerStylesList(layer) {
      if (!layer.style || (!layer.style.uniques && !layer.style.ranges)) return;
      return (layer.style.uniques ? this.$_objectToArray(layer.style.uniques.values) : layer.style.ranges.values).map(
        value => {
          return {
            ...value,
            key: value.label || value.label === '' ? value.label : value.value,
          };
        }
      );
    },
    getLayerChangeVisibilityTooltip(isVisible, geometryType, hasPermission, isModifySnappingActive) {
      return isModifySnappingActive
        ? this.$i18n.t('button.toChangeLayerVisibility', { reason: this.$i18n.t('button.turnOffEditing') })
        : geometryType === null
        ? this.$i18n.t('button.layerWithoutGeometry')
        : hasPermission
        ? this.$i18n.t('button.layerVisbility', { onOff: this.$i18n.t(`button.${isVisible ? 'off' : 'on'}`) })
        : this.$i18n.t('button.changeLayerVisibilityNoPermission');
    },
    getLayerTooltip(layer) {
      if (layer.has_permission && !this.getIsLayerHiddenByZoom(layer)) {
        return layer.name;
      } else if (!layer.has_permission) {
        return this.$i18n.t('sidebar.noLayerPermissions');
      } else if (this.getIsLayerHiddenByMinzoom(layer)) {
        return this.$i18n.t('sidebar.layerMinZoomVisibility', { suffix: layer.style.minzoom });
      } else if (this.getIsLayerHiddenByMaxzoom(layer)) {
        return this.$i18n.t('sidebar.layerMaxZoomVisibility', { suffix: layer.style.maxzoom });
      } else {
        return layer.name;
      }
    },
    getLayerVisible(layer) {
      return layer.has_permission && layer.visible && layer.geometry_type !== null;
    },
    getIsLayerHiddenByZoom(layer) {
      return this.getIsLayerHiddenByMinzoom(layer) || this.getIsLayerHiddenByMaxzoom(layer);
    },
    getIsLayerHiddenByMinzoom(layer) {
      if (layer.style?.uniques || layer.style?.ranges || !layer.style?.minzoom) {
        return false;
      } else {
        return layer.style?.minzoom > this.zoom;
      }
    },
    getIsLayerHiddenByMaxzoom(layer) {
      if (layer.style?.uniques || layer.style?.ranges || !layer.style?.maxzoom) {
        return false;
      } else {
        return layer.style?.maxzoom < this.zoom;
      }
    },
    getDataSourceIcon(layerType) {
      if (layerType === 'point' || layerType === 'multipoint') {
        return '$point';
      } else if (layerType === 'linestring' || layerType === 'multilinestring') {
        return 'mdi-vector-line';
      } else if (layerType === 'polygon' || layerType === 'multipolygon') {
        return 'mdi-vector-polygon';
      } else if (layerType === 'xyz' || layerType === 'wms' || layerType === 'wmts') {
        return '$wms';
      } else {
        return 'mdi-table-large';
      }
    },
    getStyleExternalGraphicIcon(name) {
      return `${process.env.VUE_APP_API_URL}/icons/${name}`;
    },
    getStyleIconColor(style, isGeom = true) {
      if (style && isGeom) {
        return style['fill-color'] || style['circle-color'] || style['line-color'] || '#000000';
      } else {
        return 'rgba(0, 0, 0, 0.7)';
      }
    },
    getStyleClassOthersValue(styleClass) {
      return styleClass.value || styleClass.value === false || styleClass.value === '' || styleClass.value === 0
        ? styleClass.label || styleClass.label === ''
          ? styleClass.label
          : styleClass.value
        : this.$i18n.t('default.others');
    },
  },
};
